import React from 'react'
import { ApiProduct } from '@vend/types'
import {
  VariantPicker,
  InitialVariantAttributeConfig,
} from '@vend/business-components'
import { reactular } from '@vendhq/reactular'

export interface VariantPickerModalProps {
  close: (val?: Promise<any>) => void
  options: {
    title?: string
    parentProduct: ApiProduct
    variantProducts: ApiProduct[]
    allowVariantParentSelect: boolean
    showAddValue: boolean
    initialVariantAttributeConfig?: InitialVariantAttributeConfig
  }
}

export const VariantPickerModal: React.FC<VariantPickerModalProps> = ({
  close,
  options: {
    title,
    parentProduct,
    variantProducts,
    allowVariantParentSelect,
    showAddValue,
    initialVariantAttributeConfig,
  },
}) => (
  <VariantPicker
    close={close}
    title={title}
    parentProduct={parentProduct}
    variantProducts={variantProducts}
    allowParentSelect={allowVariantParentSelect}
    showAddValue={showAddValue}
    initialVariantAttributeConfig={initialVariantAttributeConfig}
  />
)

const srVariantPickerModal = reactular(
  VariantPickerModal,
  ['close', 'options'],
  'reactWrapper'
)

export { srVariantPickerModal }
